import { Controller } from "@hotwired/stimulus";

export default class PopOutManagerController extends Controller<HTMLElement> {
  private domObserver: MutationObserver | null = null;
  private lastPopoutId: string | null = null;

  connect() {
    this.domObserver = new MutationObserver(this.eventPopOutChanges);
    this.domObserver.observe(this.element, {
      attributes: false,
      childList: true,
      subtree: false,
    });
  }

  disconnect() {
    this.domObserver?.disconnect();
    this.domObserver = null;
  }

  private eventPopOutChanges = () => {
    const popOut = this.element.children[0];

    if (!popOut) {
      this.lastPopoutId = null;
      return;
    }

    if (this.lastPopoutId !== popOut.id) {
      this.lastPopoutId = popOut.id || null;
      popOut.classList.add("puts-pop-out--slide-in-animation");
    }
  };
}
